import React, { Component } from "react";

// Redux
import { connect } from "react-redux";

import { Row, Col } from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import Flatpickr from "react-flatpickr";

import moment from "moment";

import { filter, map, flatten, find, uniqBy, sortBy } from "lodash";

import Loading from "components/Loading";

import { getDatesByBranch } from "store/actions";

import Emitter from "helpers/emitter_helper";
import { formatCurrentDateInTimezone, formatMonthStartInTimezone, formatSlotDateInTimezone, normalizeTimezone } from "helpers/timezone_helper";
import { getBranchTimezone } from "services/appointments";

class FechaAlt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validated: false,
      filteredSchedules: [],
      branchId: null,
      hours: [],
      date: null,
      hour: null,
      startAt: null,
      endAt: null,
      key: 1
    };
    this._isMounted = false;
    this.loadSequence = 0;
  }

  getScheduleBranchRequests(filteredSchedules) {
    return flatten(filteredSchedules.map((fs) => {
      return fs.branches.map((b) => {
        return {
          scheduleName: fs.name,
          scheduleId: fs.id,
          branchId: b.id
        };
      });
    }));
  }

  dispatchDatesByBranch(requests, getStrDate, loadKey) {
    if (!this._isMounted || loadKey !== this.loadSequence) {
      return;
    }

    requests.forEach((request) => {
      this.props.getDatesByBranch(
        request.scheduleName,
        request.scheduleId,
        request.branchId,
        getStrDate(request.timezone),
        request.timezone
      );
    });
  }

  loadDatesByBranch(filteredSchedules, getStrDate) {
    const loadKey = ++this.loadSequence;
    const requests = this.getScheduleBranchRequests(filteredSchedules);

    Promise.all(requests.map((request) => {
      return getBranchTimezone(request.branchId)
        .then((response) => {
          return { ...request, timezone: normalizeTimezone(response) };
        })
        .catch(() => {
          return { ...request, timezone: normalizeTimezone() };
        });
    })).then((requestsWithTimezone) => {
      this.dispatchDatesByBranch(requestsWithTimezone, getStrDate, loadKey);
    });
  }

  componentDidMount() {
    this._isMounted = true;

    Emitter.on('RESET', (value) => {
      this.setState({ key: this.state.key + 1 });
    });

    Emitter.on('SCHEDULE_SELECTED', (value) => {
      if (value) {
        let filteredSchedules = filter(this.props.schedules, ['name', value]);
        this.setState({ filteredSchedules });
        this.loadDatesByBranch(filteredSchedules, (timezone) => formatCurrentDateInTimezone(timezone));
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    Emitter.off('RESET');
    Emitter.off('SCHEDULE_SELECTED');
  }

  //eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props !== prevProps && !this.props.enabledDatesByBranch.length) {
      this.setState({ hours: [], date: null, hour: null, startAt: null, endAt: null });
    }
  }

  isValidated() {
    return this.state.startAt && this.state.endAt;
  }

  handleMonthChange(selectedDates, dateStr, instance) {
    if (!this.props.loading) {
      this.loadDatesByBranch(
        this.state.filteredSchedules,
        (timezone) => formatMonthStartInTimezone(instance.currentYear, instance.currentMonth, timezone)
      );
    }

    this.setState({ hours: [], startAt: null, endAt: null, date: null, hour: null });
  }

  handleYearChange(selectedDates, dateStr, instance) {
    if (!this.props.loading) {
      this.loadDatesByBranch(
        this.state.filteredSchedules,
        (timezone) => formatMonthStartInTimezone(instance.currentYear, instance.currentMonth, timezone)
      );
    }

    this.setState({ hours: [], startAt: null, endAt: null, date: null, hour: null });
  }

  selectDate(date) {
    let selected = moment(date.date[0]).format('YYYY-MM-DD');
    let filtered = filter(this.props.datesByBranch, { formattedDate: selected });
    
    let hours = filtered.filter((h) => { return h.availability > 0 }).map((f) => {
      f.formattedHour = formatSlotDateInTimezone(f.zonedStartDate || f.startDate, f.timezone).format('HH:mm');

      return f;
    });

    hours = sortBy(uniqBy(hours, 'formattedHour'), 'formattedHour');

    // Get branch quantity per hour
    hours.map((h) => {
      const filteredBranches = this.props.datesByBranch.filter((d) => {
        return d.zonedStartDate == h.zonedStartDate;
      });

      const qty = this.props.branches.filter((b) => {
        return map(filteredBranches, 'branchId').includes(b.id);
      });

      h.branches = qty.length;

      return h;
    });

    Emitter.emit('BREADCRUMB_DATE', moment(date.date[0]).format('DD/MM/YYYY'));
    
    this.setState({ hours, date, hour: null });
  }

  setHour(event) {
    let hour = find(this.state.hours, { formattedHour: event.target.value });
    let startDate = formatSlotDateInTimezone(hour.zonedStartDate || hour.startDate, hour.timezone);

    this.setState({
      startAt: startDate.format('YYYY-MM-DDTHH:mm:ssZZ'),
      endAt: startDate.clone().add(hour.defaultDuration, 'minutes').format('YYYY-MM-DDTHH:mm:ssZZ'),
      hour: event.target.value
    });

    Emitter.emit('DATE_HOUR_SELECTED', hour.zonedStartDate);
    Emitter.emit('BREADCRUMB_DATE', startDate.format('DD/MM/YYYY') + ' ' + startDate.format('HH:mm'));
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col className="pl-0" md={{ size: 3, offset: 1 }} xs={{ size: 12 }}>
            <Flatpickr
              key={this.state.key}
              className="form-control d-block"
              options={{
                locale: Spanish,
                inline: true,
                enable: this.props.enabledDatesByBranch
              }}
              onChange={date => {
                this.selectDate({ date });
              }}
              onMonthChange={(selectedDates, dateStr, instance) => this.handleMonthChange(selectedDates, dateStr, instance) }
              onYearChange={(selectedDates, dateStr, instance) => this.handleYearChange(selectedDates, dateStr, instance)}
            />
          </Col>
          <Col className="hour-selection" xs={12} md={{ size: 5, offset: 1 }}>
            {this.props.loading ?
              <Loading />
              :
              <Row>
              {
                this.state.hours.map((hour, index) => (
                  <Col className="px-xs-0" key={index} md={4} xs={12}>
                    <div className="custom-radio mb-0">
                      <input id={'date-' + index} name="hours" type="radio" checked={this.state.hour == hour.formattedHour} value={hour.formattedHour} onChange={this.setHour.bind(this)} />
                      <label htmlFor={'date-' + index} className="mb-0">{hour.formattedHour}</label>
                    </div>
                    <div className="branch-qty">{hour.branches} SEDES</div>
                  </Col>
                ))
              }
              {
                ((!this.state.hours.length && this.state.date) || !this.props.enabledDatesByBranch.length) && (
                  <Col className="px-xs-0">
                    No hay horarios disponibles.
                  </Col>
                )
              }
              </Row>
            }
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const { loading, schedules, branches, enabledDatesByBranch, datesByBranch, error } = state.Home;
  return {
    loading, schedules, branches, enabledDatesByBranch, datesByBranch, error
  };
}

export default connect(mapStateToProps, {
  getDatesByBranch
}, null, { forwardRef: true })(FechaAlt);

